import React from 'react';

// ★ 需求 3：本月已收學費 → 點擊後彈出的付款明細 Modal
export default function PaymentDetailModal({ students, currentYear, currentMonth, onClose }) {
  const rows = [];

  students.forEach(student => {
    (student.payments || []).forEach(p => {
      if (!p.date || p.isProxy) return; // 所有代付紀錄一律排除，代付非實收
      const d = new Date(p.date);
      if (d.getFullYear() !== currentYear || d.getMonth() + 1 !== currentMonth) return;
      if (!Number(p.amount)) return;
      rows.push({
        date: p.date,
        studentName: student.name,
        amount: Number(p.amount),
        lessons: Number(p.lessons) || 0,
        notes: p.notes || '',
      });
    });
  });

  // 依日期排序
  rows.sort((a, b) => new Date(a.date) - new Date(b.date));
  const total = rows.reduce((s, r) => s + r.amount, 0);

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.modal} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={S.header}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 500 }}>本月已收學費明細</div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{currentYear} 年 {currentMonth} 月</div>
          </div>
          <button style={S.closeBtn} onClick={onClose}>×</button>
        </div>

        {/* 表格 */}
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {rows.length === 0 ? (
            <div style={{ padding: '32px 0', textAlign: 'center', fontSize: 13, color: '#aaa' }}>
              本月尚無付款紀錄
            </div>
          ) : (
            <table style={S.table}>
              <thead>
                <tr style={S.thead}>
                  <th style={S.th}>日期</th>
                  <th style={S.th}>學員</th>
                  <th style={{ ...S.th, textAlign: 'right' }}>入帳金額</th>
                  <th style={S.th}>堂數 / 備註</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={S.td}>{r.date}</td>
                    <td style={{ ...S.td, fontWeight: 500 }}>{r.studentName}</td>
                    <td style={{ ...S.td, textAlign: 'right', fontWeight: 500, color: '#188038' }}>
                      ${r.amount.toLocaleString()}
                    </td>
                    <td style={{ ...S.td, color: '#888', fontSize: 11 }}>
                      {r.lessons > 0 ? `${r.lessons} 堂` : ''}{r.notes ? (r.lessons > 0 ? `　${r.notes}` : r.notes) : ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Footer：加總 */}
        <div style={S.footer}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
            <span style={{ fontSize: 12, color: '#888' }}>本月合計</span>
            <span style={{ fontSize: 22, fontWeight: 500, color: '#188038' }}>${total.toLocaleString()}</span>
            {rows.length > 0 && <span style={{ fontSize: 12, color: '#aaa' }}>共 {rows.length} 筆</span>}
          </div>
          <button style={S.closeMainBtn} onClick={onClose}>關閉</button>
        </div>
      </div>
    </div>
  );
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 600,
  },
  modal: {
    background: '#fff', borderRadius: 12, border: '0.5px solid #e0e0e0',
    width: 560, maxWidth: '96vw', maxHeight: '85vh',
    display: 'flex', flexDirection: 'column',
  },
  header: {
    display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
    padding: '14px 20px', borderBottom: '0.5px solid #eee', flexShrink: 0,
  },
  closeBtn: {
    background: 'none', border: 'none', fontSize: 22, color: '#888',
    cursor: 'pointer', lineHeight: 1, marginTop: -2,
  },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  thead: { background: '#f8f8f8' },
  th: {
    padding: '9px 14px', textAlign: 'left', fontWeight: 500,
    color: '#666', fontSize: 11, borderBottom: '0.5px solid #e0e0e0',
    letterSpacing: '0.03em',
  },
  td: { padding: '9px 14px', borderBottom: '0.5px solid #f0f0f0', fontSize: 13 },
  footer: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '14px 20px', borderTop: '0.5px solid #eee', flexShrink: 0,
  },
  closeMainBtn: {
    padding: '7px 20px', borderRadius: 8, fontSize: 13,
    background: '#222', border: 'none', color: '#fff', cursor: 'pointer', fontWeight: 500,
  },
};
